import React, { useState, useEffect, useRef, Fragment } from "react";
import classnames from "classnames";
import NumberFormat from "react-number-format";
import Skeleton from "react-loading-skeleton";
//import axiosInstance from "./../../helpers/axiosInstance";
import MyModal from "components/Modal/Modal";
//import santander from '../../assets/img/brand/santander.png';
//import exitoCreacion from '../../assets/img/illustrations/add-contact-success.svg';
//import ComponentemodificaUsu from './modificaUsuario.js'

//import IconTid from '../../assets/img/icons/Icono-Tipo-de-documento-Gris.png'


//import icon_Administras_usuarios from 'assets/img/icons/Icono-Administrar-Usuarios-Gris.png'
//import icon_Administras_usuariosA from 'assets/img/icons/Icono-Administrar-Usuarios-Rojo.png'


// reactstrap components
import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
  Modal,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  CardHeader,
  Button,
  FormGroup,
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import { normalizeUnits } from "moment";
import { tr } from "date-fns/locale";
//import basePerfiles from "./basePerfiles.js";
//import baseUsuarios from "./baseUsu.js";
import { set } from "date-fns";
//import baseTransaccionPen from "./baseTransaccionesPen.js";
//import Compotp from "./Compotp";
//import Checksantader from "./Checksantander";
//import Confirmmodal from "./Confirmmodal";
//import perf from "./basePerfiles.js";
import IconNid from '../../../assets/img/icons/Icono-Numero-documento-Gris.png';
//import IconCorreo from '../../assets/img/icons/Icono-Correo-Gris.png';
//import IconNom from '../../assets/img/icons/Cliente-Gris2x.png';
//import IconCel from '../../assets/img/icons/Telefono-Gris2x.png';
//import IconPesos from '../../assets/img/icons/Tope_Monto_Transaccional-Gris2x.png';
//import IconMas from '../../assets/img/icons/circulo-mas.png';
//import IconMasRojo from '../../assets/img/icons/circulo-mas-Rojo.png';
//import IconEliminar from '../../assets/img/icons/IconoEliminar.png';
//import IconEliminarRojo from '../../assets/img/icons/iconoEliminarRojo.png';

//import BotonEliminaIp from "./botoneliminarIp";
//import Campoformato from "./campoformato";
import { event } from "jquery";
import {useDispatch} from "react-redux";
import {cambiaruta,cambiasidebar} from "../../../Slicersreducers";
import CalendarioNuevo from "../CalendarioNuevo";
//import { Console } from "console";
const _=require("lodash");

const Formetapa1=(props)=>{
    const refdesdom=useRef(null);
    const reftipdom=useRef(null);
    const refvaldom=useRef(null);
    const [desdom, setdesdom]=useState(props.data.des);
    const [tipooperacion,settipooperacion]=useState(props.data.tipop);
    const [tipoelec,settipoelec]=useState(props.data.arrtipos);
    const [valorasoc,setvalorasoc]=useState(props.data.valasoc);

    const editades=(event)=>{
        event.preventDefault();
        props.quitaalertas();
        setdesdom(event.target.value);
        console.log(desdom);
        refdesdom.current.focus();
      }
    function getTypeoperation(event) {
      //auxBuildAccount.accountType = type;
      //setNewUser({...newUser, TidUser: type});
      props.quitaalertas();
      settipooperacion(event.target.value);
      console.log(event.target.value);
        switch(event.target.value){
          case "1":
            settipoelec([true,false,false]);
  
            break;
          case "2":
            settipoelec([false,true,false]);
  
            break;
          case "3":
              settipoelec([false,false,true]);
          break;
        }
    }
    const cambioValor = (event) => {
      event.preventDefault();
      props.quitaalertas();
      let val = event.target.value;
      setvalorasoc(val.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ","));
      //console.log(topesxprod);
      refvaldom.current.focus();
    };
    const AvanzaStep=()=>{
      props.funcionpadre(1,{desdom,tipooperacion,tipoelec,valorasoc})
    }
    return(
      <Fragment>
        <div className="conformdom">
            <div className="contcentraldomi">
                <p class="header-subtitle">En este espacio podrás crear una nueva condición
                    de asociación. Recuerda diligenciar todos los campos
                    </p>
                <div className="inputs-icons-borderbott">
                <input
                    maxLength={50}
                    className="form-control h5 p-1"
                    placeholder="Descripción"
                    type="text"
                    ref={refdesdom}
                    style={{fontSize:"14px",border:"none", width:"90%",height:"33px",padding:"0px 0px 0px 0px",margin:"0px 0px 0px 0px"}}
                    onChange={editades}
                    value={desdom}
                />
                {/*<img style={{height:"12px", }} src={IconNid}></img>*/}
                </div>
                <div className="inputs-icons-borderbott">
                    <select
                        onChange={getTypeoperation}
                        placeholder="Tipo de operacion"
                        style={{border:"none",width:"100%",fontSize:"14px",height:"33px"}}
                    >
                        <option value="1" selected={tipoelec[0]}>Transferencia interna</option>
                        <option value="2" selected={tipoelec[1]}>Transferencia externa</option>
                        <option value="3" selected={tipoelec[2]}>Pago crédito</option>
                    </select>
                    <img style={{height:"12px", }} src={IconNid}></img>
                </div>
                <div className="inputs-icons-borderbott">
                    <input
                        maxLength={30}
                        className="form-control h5 p-1"
                        placeholder="Valor de la transferencia o utilización"
                        type="text"
                        ref={refvaldom}
                        style={{fontSize:"14px",border:"none", width:"250px",height:"25px",padding:"0px 0px 0px 0px",margin:"0px 0px 0px 0px"}}
                        onChange={cambioValor}
                        value={valorasoc}
                    />
                    <img style={{height:"12px", }} src={IconNid}></img>
                </div>
            </div>
            <button
                className="bg-green text-white btn btn-rounded btn-block mb-3 ml-auto mr-auto"
                style={{width:"25%"}}
                onClick={()=>{
                  AvanzaStep(1);
                }}
            >
                Continuar
            </button>

        </div>

        
      </Fragment>
    )

}
export default Formetapa1;